module.exports = __webpack_public_path__ + "img/profielfoto_sint.afc6bf6c.jpg";